const staticPixels = "";

export { staticPixels };